import { Component, ViewChild } from '@angular/core';

// extends
import { RegistrationPage } from "../../../registration/registration.page";

@Component({
    selector: 'app-registration',
    templateUrl: './registration.page.html',
    styleUrls: ['./registration.page.scss'],
})
export class CustomRegistrationPage extends RegistrationPage {
    /**
     * if we should show sidebar
     *
     * @type {boolean}
     */
    public hideSidebar: boolean = true;

    public source: string = '';

    /**
     * Form
     *
     * @type ViewChild
     */
    @ViewChild('f') private form;

    public initSetting() {

        this.model.event_id = 655;
        this.model.group_id = 451;
        this.model.external_secret_verification = '8b976429ee4e5884c8d24c49d71e56935e2a3830';

        if (location.hostname != 'app.skillsclub.com') {
            this.model.event_id = 598;
            this.model.group_id = null;
            this.model.external_secret_verification = '05567a3e7b2cfee5d93d71a336198386af1fbd93';
        }

        // preset keys for subcommunity
        if (this.themeConfig.eventKey) {
            this.model.event_key = this.themeConfig.eventKey;
        }

        // get event key from url
        if (this.route.snapshot.params['event-key']) {
            this.model.event_key = decodeURIComponent(this.route.snapshot.params['event-key']);
        }

        // set source attribute if provided
        if (this.route.snapshot.queryParams['source']) {
            this.source = '_' + decodeURIComponent(this.route.snapshot.queryParams['source']);
        }

        // follow invitation - token must be added to every possible request from here
        const external_secret = this.route.snapshot.queryParams['uid'];
        if (!!external_secret) {
            this.showLoading();
            this.participantService.getByInvitationExternalSecret(external_secret).subscribe(
                (participant: any) => {
                    this.hideLoading();
                    setTimeout(() => {
                        this.hideLoading();
                    }, 1000);
                    setTimeout(() => {
                        this.hideLoading();
                    }, 5000);
                    this.model.copyDataFromParticipant(participant);
                    if (participant.email) {
                        this.invited = true;
                        this.storage.set('external_secret', external_secret);
                    } else {
                        // invitation token is not valid
                        this.showError(this.translate.instant('ERROR_INVALID_EXTERNAL_SECRET'));
                        this.router.navigate(['/login']);
                    }
                }, (error) => {
                    this.hideLoading();
                    setTimeout(() => {
                        this.hideLoading();
                    }, 1000);
                    setTimeout(() => {
                        this.hideLoading();
                    }, 5000);
                });
        } else {
            this.storage.get('external_secret').then((external_secret) => {
                if (!!external_secret) {
                    this.showLoading();
                    this.participantService.getByInvitationExternalSecret(external_secret).subscribe(
                        (participant: any) => {
                            this.hideLoading();
                            setTimeout(() => {
                                this.hideLoading();
                            }, 1000);
                            setTimeout(() => {
                                this.hideLoading();
                            }, 5000);
                            this.model.copyDataFromParticipant(participant);
                            if (participant.email) {
                                this.invited = true;
                            } else {
                                // invitation token is not valid
                                this.storage.remove('external_secret');
                                this.showError(this.translate.instant('ERROR_INVALID_EXTERNAL_SECRET'));
                                this.router.navigate(['/login']);
                            }
                        }, (error) => {
                            this.hideLoading();
                            setTimeout(() => {
                                this.hideLoading();
                            }, 1000);
                            setTimeout(() => {
                                this.hideLoading();
                            }, 5000);
                        });
                }
            });
        }
    }

    public canSubmit() {
        this.validate = true;
        return this.form.valid;
    }
}
